import { SaveTipoAccion } from "../../components";

export default function CreateTipoAccionPage() {
  return <SaveTipoAccion titulo="Crear tipo de acción" />;
}
